'use client'
import {
  USER_DATA_STORAGE_KEY
} from "./chunk-T2NN7R53.mjs";

// src/utils/user.ts
import { setItem } from "@wbk/utils";
var setUserInLocalStorage = (user) => {
  setItem(USER_DATA_STORAGE_KEY, JSON.stringify(user));
};

export {
  setUserInLocalStorage
};
//# sourceMappingURL=chunk-4RITNUKZ.mjs.map